import React, { memo } from 'react';
import { CTAButton, CHECKOUT_URL, CountdownTimer, Section } from './Shared';
import { Check, X, Star, ShieldCheck, BookOpen, Brain, Target, Award, Gift } from 'lucide-react';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/kvZPEUBH8yZxPbcHDVFMHn/NEUROAVANCE_MOCKUP.png';
const BONUS_IMAGES = ['https://cdn.magicpatterns.com/uploads/tESS1uapFwumxmihHuSaN1/bononeuro1.png', 'https://cdn.magicpatterns.com/uploads/m41zTMSgBY2CLkJid8YvXw/bononeuro2.png', 'https://cdn.magicpatterns.com/uploads/7qerGbZGLDWVkL85zikq7Z/bononeuro3.png', 'https://cdn.magicpatterns.com/uploads/opx8QuyowHFDyBfzqthBAg/bononeuro4.png', 'https://cdn.magicpatterns.com/uploads/gbyrfq8VzKvbPhb86jtZx9/bononeuro5.png'];
export const HeroSection = () => <Section className="bg-gradient-to-b from-blue-50 to-white pt-8 sm:pt-12" data-id="element-21">
    <div className="text-center" data-id="element-22">
      <h1 className="font-montserrat font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-slate-900 leading-tight mb-6" data-id="element-23">
        ¿Tu hijo se{' '}
        <span className="text-red-600 underline decoration-4 underline-offset-4" data-id="element-24">
          distrae fácilmente
        </span>{' '}
        cuando estudia?
      </h1>

      <a href={CHECKOUT_URL} className="block w-full max-w-3xl mx-auto mb-8 hover:opacity-95 transition-opacity" data-id="element-25">
        <img src={MAIN_IMAGE} alt="Sistema NeuroAvance Para Niños" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-26" />
      </a>

      <p className="font-inter text-lg sm:text-xl md:text-2xl text-slate-700 mb-8 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-27">
        Descubre el sistema diseñado para fortalecer la{' '}
        <strong className="text-blue-700" data-id="element-28">
          atención, memoria, comprensión y razonamiento
        </strong>{' '}
        mediante actividades prácticas que puedes aplicar desde casa en solo 15
        minutos al día.
      </p>

      <div className="bg-yellow-100 border-2 border-yellow-400 rounded-xl p-4 inline-block mb-8 transform -rotate-1" data-id="element-29">
        <p className="font-montserrat font-black text-2xl sm:text-3xl text-slate-900" data-id="element-30">
          🔥 HOY SOLO{' '}
          <span className="text-red-600 text-4xl sm:text-5xl" data-id="element-31">USD $10.99</span>
        </p>
      </div>

      <CountdownTimer data-id="element-32" />
      <CTAButton text="🧠 QUIERO ACCEDER AHORA" className="mt-4" data-id="element-33" />

      <div className="flex items-center justify-center gap-4 mt-6 text-sm font-inter text-slate-500" data-id="element-34">
        <span className="flex items-center gap-1" data-id="element-35">
          <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-36" /> Compra Segura
        </span>
        <span className="flex items-center gap-1" data-id="element-37">
          <Star className="w-4 h-4 text-yellow-500" fill="currentColor" data-id="element-38" /> 5.0
          (1,000+ padres)
        </span>
      </div>
    </div>
  </Section>;
export const ProblemSection = () => <Section className="bg-white" data-id="element-39">
    <h2 className="font-montserrat font-black text-2xl sm:text-3xl md:text-4xl text-center mb-10 text-slate-900" data-id="element-40">
      ¿Tu hijo presenta alguno de estos problemas?
    </h2>
    <div className="bg-red-50 rounded-2xl p-6 sm:p-8 border border-red-100 shadow-sm max-w-2xl mx-auto mb-10" data-id="element-41">
      <ul className="space-y-4" data-id="element-42">
        {['Se distrae fácilmente con cualquier cosa', 'Le cuesta concentrarse en sus tareas', 'Olvida rápidamente lo que aprende', 'Tiene problemas para comprender lo que lee', 'Pierde interés rápidamente en el estudio', 'Necesita ayuda constante para estudiar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-43">
            <div className="bg-red-100 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-44">
              <X className="w-5 h-5 text-red-600" strokeWidth={3} data-id="element-45" />
            </div>
            <span className="font-inter text-lg sm:text-xl text-slate-800 font-medium" data-id="element-46">
              {item}
            </span>
          </li>)}
      </ul>
    </div>
    <CTAButton text="🚀 QUIERO AYUDAR A MI HIJO" data-id="element-47" />
  </Section>;
export const OpportunitySection = () => <Section dark className="bg-slate-900" data-id="element-48">
    <div className="text-center max-w-3xl mx-auto" data-id="element-49">
      <h2 className="font-montserrat font-black text-3xl sm:text-4xl md:text-5xl text-yellow-400 mb-8" data-id="element-50">
        El problema no es la inteligencia.
      </h2>
      <div className="space-y-6 font-inter text-lg sm:text-xl text-slate-300 leading-relaxed" data-id="element-51">
        <p data-id="element-52">Muchos niños no tienen problemas para aprender.</p>
        <p className="text-white font-semibold text-xl sm:text-2xl" data-id="element-53">
          Simplemente nunca han desarrollado habilidades fundamentales como la
          atención, la memoria, la comprensión y el razonamiento.
        </p>
        <p data-id="element-54">
          La buena noticia es que estas habilidades pueden fortalecerse mediante
          actividades adecuadas y consistentes.
        </p>
      </div>
    </div>
    <div className="mt-12" data-id="element-55">
      <CTAButton text="✅ QUIERO VER EL SISTEMA" data-id="element-56" />
    </div>
  </Section>;
export const SystemSection = () => <Section className="bg-slate-50" data-id="element-57">
    <div className="text-center mb-12" data-id="element-58">
      <h2 className="font-montserrat font-black text-3xl sm:text-4xl text-slate-900 mb-4" data-id="element-59">
        Presentamos el Sistema NeuroAvance Para Niños™
      </h2>
      <p className="font-inter text-xl text-slate-600 font-medium" data-id="element-60">
        Un programa completo compuesto por 7 módulos especializados.
      </p>
    </div>

    <a href={CHECKOUT_URL} className="block w-full max-w-4xl mx-auto mb-12 hover:opacity-95 transition-opacity" data-id="element-61">
      <img src={MAIN_IMAGE} alt="7 Módulos del Sistema" className="w-full h-auto rounded-xl shadow-xl" data-id="element-62" />
    </a>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto mb-12" data-id="element-63">
      {[{
      title: 'Atención y Concentración',
      icon: Target,
      color: 'text-green-600',
      bg: 'bg-green-100'
    }, {
      title: 'Memoria Inteligente',
      icon: Brain,
      color: 'text-purple-600',
      bg: 'bg-purple-100'
    }, {
      title: 'Comprensión y Lectura',
      icon: BookOpen,
      color: 'text-blue-600',
      bg: 'bg-blue-100'
    }, {
      title: 'Razonamiento y Lógica',
      icon: Target,
      color: 'text-orange-600',
      bg: 'bg-orange-100'
    }, {
      title: 'Percepción Visual',
      icon: Target,
      color: 'text-teal-600',
      bg: 'bg-teal-100'
    }, {
      title: 'Motricidad Fina',
      icon: Target,
      color: 'text-pink-600',
      bg: 'bg-pink-100'
    }, {
      title: 'Plan NeuroAvance de 30 Días',
      icon: Award,
      color: 'text-yellow-600',
      bg: 'bg-yellow-100'
    }].map((mod, i) => <div key={i} className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm border border-slate-100" data-id="element-64">
          <div className={`${mod.bg} p-3 rounded-lg`} data-id="element-65">
            <mod.icon className={`w-6 h-6 ${mod.color}`} data-id="element-66" />
          </div>
          <span className="font-montserrat font-bold text-slate-800 text-lg" data-id="element-67">
            📘 {mod.title}
          </span>
        </div>)}
    </div>

    <CTAButton text="🧠 ACCEDER AL SISTEMA" data-id="element-68" />
  </Section>;
export const ContentDemoSection = () => <Section className="bg-white" data-id="element-69">
    <div className="text-center mb-10" data-id="element-70">
      <h2 className="font-montserrat font-black text-2xl sm:text-3xl md:text-4xl text-slate-900 mb-6" data-id="element-71">
        Más de 100 actividades diseñadas para fortalecer habilidades importantes
        para el aprendizaje.
      </h2>
      <p className="font-inter text-lg text-slate-600" data-id="element-72">
        El producto es un sistema completo de aprendizaje, no un simple archivo
        digital.
      </p>
    </div>

    <a href={CHECKOUT_URL} className="block w-full max-w-4xl mx-auto mb-10 hover:opacity-95 transition-opacity" data-id="element-73">
      <img src={MAIN_IMAGE} alt="Páginas internas y actividades" className="w-full h-auto rounded-xl shadow-lg border border-slate-200" data-id="element-74" />
    </a>

    <CTAButton text="🚀 QUIERO ACCESO INMEDIATO" data-id="element-75" />
  </Section>;
export const BenefitsSection = () => <Section className="bg-blue-50" data-id="element-76">
    <h2 className="font-montserrat font-black text-3xl sm:text-4xl text-center mb-10 text-slate-900" data-id="element-77">
      Lo que tu hijo podrá desarrollar
    </h2>
    <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md max-w-2xl mx-auto mb-10 border border-blue-100" data-id="element-78">
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-79">
        {['Mejor atención', 'Mayor concentración', 'Mejor memoria', 'Mejor comprensión', 'Más seguridad para aprender', 'Mejores hábitos de estudio', 'Mayor confianza'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-80">
            <div className="bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-81">
              <Check className="w-5 h-5 text-green-600" strokeWidth={3} data-id="element-82" />
            </div>
            <span className="font-inter text-lg text-slate-800 font-bold" data-id="element-83">
              {item}
            </span>
          </li>)}
      </ul>
    </div>
    <CTAButton text="🔥 QUIERO COMENZAR HOY" data-id="element-84" />
  </Section>;
export const TestimonialsSection = () => <Section className="bg-white" data-id="element-85">
    <div className="text-center mb-12" data-id="element-86">
      <h2 className="font-montserrat font-black text-3xl sm:text-4xl text-slate-900 mb-4" data-id="element-87">
        Lo que están diciendo otros padres sobre el Sistema NeuroAvance Para
        Niños™
      </h2>
      <p className="font-inter text-xl text-slate-600" data-id="element-88">
        Miles de padres buscan herramientas para ayudar a sus hijos a
        desarrollar mejores hábitos de aprendizaje.
      </p>
    </div>

    <div className="flex items-center justify-center gap-2 mb-10" data-id="element-89">
      <div className="flex" data-id="element-90">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 text-yellow-400" fill="currentColor" data-id="element-91" />)}
      </div>
      <span className="font-montserrat font-bold text-lg text-slate-800" data-id="element-92">
        Más de 1,000 familias beneficiadas
      </span>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12" data-id="element-93">
      {[{
      name: 'Laura M.',
      text: 'Mi hijo se distraía muchísimo cuando hacía sus tareas. Después de aplicar las actividades del Sistema NeuroAvance empezó a mantenerse enfocado por más tiempo.'
    }, {
      name: 'Carmen R.',
      text: 'Las actividades son fáciles de aplicar desde casa y mi hija disfruta realizarlas todos los días.'
    }, {
      name: 'Diego S.',
      text: 'Me sorprendió la cantidad de material incluido. Los módulos están muy bien organizados.'
    }, {
      name: 'Ana P.',
      text: 'Ahora tiene una rutina mucho más organizada y participa con más interés.'
    }, {
      name: 'Carlos V.',
      text: 'Excelente material. Muy práctico y fácil de usar.'
    }].map((t, i) => <div key={i} className="bg-slate-50 p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-94">
          <div className="flex items-center gap-2 mb-3" data-id="element-95">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center font-bold text-blue-700" data-id="element-96">
              {t.name.charAt(0)}
            </div>
            <div data-id="element-97">
              <p className="font-bold font-inter text-slate-900" data-id="element-98">{t.name}</p>
              <div className="flex" data-id="element-99">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400" fill="currentColor" data-id="element-100" />)}
              </div>
            </div>
          </div>
          <p className="font-inter text-slate-700 italic" data-id="element-101">"{t.text}"</p>
        </div>)}
    </div>

    {/* WhatsApp Style Testimonial Mock */}
    <div className="max-w-md mx-auto bg-[#e5ddd5] p-4 rounded-xl shadow-inner mb-10 border border-gray-300" data-id="element-102">
      <div className="bg-white p-3 rounded-lg rounded-tl-none shadow-sm mb-3 max-w-[85%]" data-id="element-103">
        <p className="text-sm font-inter text-gray-800" data-id="element-104">
          ¡Hola! Quería contarles que estoy fascinada con los cuadernos. Mi niño
          de 6 años ya no pelea para hacer las tareas, le encantan los juegos de
          concentración. 🙏
        </p>
        <span className="text-[10px] text-gray-400 text-right block mt-1" data-id="element-105">
          10:42 AM
        </span>
      </div>
      <div className="bg-[#dcf8c6] p-3 rounded-lg rounded-tr-none shadow-sm max-w-[85%] ml-auto" data-id="element-106">
        <p className="text-sm font-inter text-gray-800" data-id="element-107">
          ¡Qué alegría leer esto! Nos emociona mucho saber que el sistema le
          está ayudando. Sigan así. 🌟
        </p>
        <span className="text-[10px] text-gray-500 text-right block mt-1" data-id="element-108">
          10:45 AM ✓✓
        </span>
      </div>
    </div>

    <CTAButton text="🚀 QUIERO ACCEDER AL SISTEMA AHORA" data-id="element-109" />
  </Section>;
export const BonusesSection = () => <Section className="bg-slate-900" dark data-id="element-110">
    <div className="text-center mb-12" data-id="element-111">
      <h2 className="font-montserrat font-black text-3xl sm:text-4xl md:text-5xl text-white mb-4" data-id="element-112">
        Además recibirás estos bonos completamente{' '}
        <span className="text-yellow-400" data-id="element-113">GRATIS</span>
      </h2>
      <p className="font-inter text-xl text-slate-300" data-id="element-114">
        Solo por el día de hoy, al adquirir el sistema te llevas todo esto sin
        costo adicional.
      </p>
    </div>

    <div className="space-y-12 max-w-3xl mx-auto mb-12" data-id="element-115">
      {[{
      title: 'Test de Evaluación Inicial',
      value: 19,
      img: BONUS_IMAGES[0]
    }, {
      title: '100 Juegos para Mejorar la Concentración',
      value: 19,
      img: BONUS_IMAGES[1]
    }, {
      title: 'Calendario de Seguimiento',
      value: 9,
      img: BONUS_IMAGES[2]
    }, {
      title: 'Guía para Reducir Distracciones',
      value: 9,
      img: BONUS_IMAGES[3]
    }, {
      title: 'Guía NeuroAvance para Padres',
      value: 19,
      img: BONUS_IMAGES[4]
    }].map((bono, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-2xl border-4 border-yellow-400 transform transition hover:scale-[1.02]" data-id="element-116">
          <div className="bg-yellow-400 py-2 text-center" data-id="element-117">
            <span className="font-montserrat font-black text-slate-900 text-xl uppercase" data-id="element-118">
              🎁 BONO {i + 1}
            </span>
          </div>
          <a href={CHECKOUT_URL} className="block w-full" data-id="element-119">
            <img src={bono.img} alt={bono.title} className="w-full h-auto" data-id="element-120" />
          </a>
          <div className="p-6 text-center" data-id="element-121">
            <h3 className="font-montserrat font-bold text-2xl text-slate-900 mb-2" data-id="element-122">
              {bono.title}
            </h3>
            <p className="font-inter text-lg text-slate-500 line-through" data-id="element-123">
              Valor USD ${bono.value}
            </p>
            <p className="font-montserrat font-black text-green-600 text-xl" data-id="element-124">
              HOY GRATIS
            </p>
          </div>
        </div>)}
    </div>

    <CTAButton text="🎁 QUIERO MIS BONOS" data-id="element-125" />
  </Section>;
export const OfferSection = () => <Section className="bg-white" data-id="element-126">
    <div className="max-w-2xl mx-auto bg-slate-50 rounded-3xl p-8 sm:p-12 border-2 border-slate-200 shadow-xl relative overflow-hidden" data-id="element-127">
      <div className="absolute top-0 right-0 bg-red-600 text-white font-bold py-1 px-10 transform translate-x-8 translate-y-4 rotate-45" data-id="element-128">
        OFERTA
      </div>

      <h2 className="font-montserrat font-black text-3xl text-center mb-8 text-slate-900" data-id="element-129">
        Resumen de lo que te llevas hoy:
      </h2>

      <div className="space-y-3 font-inter text-lg font-medium text-slate-700 mb-8" data-id="element-130">
        <p className="flex justify-between border-b border-slate-200 pb-2" data-id="element-131">
          <span data-id="element-132">📘 Atención y Concentración</span> <span data-id="element-133">$19</span>
        </p>
        <p className="flex justify-between border-b border-slate-200 pb-2" data-id="element-134">
          <span data-id="element-135">📘 Memoria Inteligente</span> <span data-id="element-136">$19</span>
        </p>
        <p className="flex justify-between border-b border-slate-200 pb-2" data-id="element-137">
          <span data-id="element-138">📘 Comprensión y Lectura</span> <span data-id="element-139">$19</span>
        </p>
        <p className="flex justify-between border-b border-slate-200 pb-2" data-id="element-140">
          <span data-id="element-141">📘 Razonamiento y Lógica</span> <span data-id="element-142">$19</span>
        </p>
        <p className="flex justify-between border-b border-slate-200 pb-2" data-id="element-143">
          <span data-id="element-144">📘 Percepción Visual</span> <span data-id="element-145">$19</span>
        </p>
        <p className="flex justify-between border-b border-slate-200 pb-2" data-id="element-146">
          <span data-id="element-147">📘 Motricidad Fina</span> <span data-id="element-148">$19</span>
        </p>
        <p className="flex justify-between border-b border-slate-200 pb-2" data-id="element-149">
          <span data-id="element-150">📘 Plan NeuroAvance</span> <span data-id="element-151">$19</span>
        </p>
        <p className="flex justify-between border-b border-slate-200 pb-2 text-green-600 font-bold" data-id="element-152">
          <span data-id="element-153">🎁 5 Bonos Exclusivos</span> <span data-id="element-154">$75</span>
        </p>
      </div>

      <div className="text-center mb-8" data-id="element-155">
        <p className="font-inter text-xl text-slate-500 mb-1" data-id="element-156">VALOR TOTAL</p>
        <p className="font-montserrat font-black text-4xl text-slate-400 line-through decoration-red-500 decoration-4" data-id="element-157">
          USD $208
        </p>
      </div>

      <div className="text-center bg-yellow-100 rounded-xl p-6 border-2 border-yellow-400 mb-8" data-id="element-158">
        <p className="font-inter font-bold text-xl text-slate-800 mb-2" data-id="element-159">
          HOY SOLO
        </p>
        <p className="font-montserrat font-black text-5xl sm:text-6xl text-red-600" data-id="element-160">
          USD $10.99
        </p>
      </div>

      <CountdownTimer data-id="element-161" />
      <CTAButton text="🚀 ACCEDER AHORA" className="mt-6" data-id="element-162" />
    </div>
  </Section>;
export const GuaranteeSection = () => <Section className="bg-slate-900 text-center" dark data-id="element-163">
    <ShieldCheck className="w-24 h-24 text-yellow-400 mx-auto mb-6" data-id="element-164" />
    <h2 className="font-montserrat font-black text-3xl sm:text-4xl text-white mb-6" data-id="element-165">
      Garantía de Satisfacción de 30 Días
    </h2>
    <p className="font-inter text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-166">
      Prueba el Sistema NeuroAvance Para Niños con total tranquilidad. Si no
      estás satisfecho, puedes solicitar ayuda dentro del período de garantía.
      Tu inversión está 100% protegida.
    </p>
  </Section>;
export const FAQSection = () => <Section className="bg-slate-50" data-id="element-167">
    <h2 className="font-montserrat font-black text-3xl sm:text-4xl text-center mb-10 text-slate-900" data-id="element-168">
      Preguntas Frecuentes
    </h2>
    <div className="max-w-3xl mx-auto space-y-4" data-id="element-169">
      {[{
      q: '¿Cuándo recibo el acceso?',
      a: 'El acceso es inmediato. Una vez completado el pago, recibirás un correo electrónico con los enlaces para descargar todo el material.'
    }, {
      q: '¿Necesito experiencia previa?',
      a: 'No, el sistema está diseñado para que cualquier padre pueda aplicarlo fácilmente siguiendo las instrucciones paso a paso.'
    }, {
      q: '¿Puedo imprimir el material?',
      a: 'Sí, todo el material viene en formato digital de alta calidad, listo para que lo imprimas en casa o en una papelería.'
    }, {
      q: '¿Funciona para diferentes edades?',
      a: 'El sistema está optimizado para niños entre 4 y 10 años, con actividades adaptables a su nivel de desarrollo.'
    }, {
      q: '¿Cuánto tiempo debo dedicar cada día?',
      a: 'Solo necesitas 15 minutos al día para empezar a ver resultados y crear el hábito.'
    }, {
      q: '¿Los bonos están incluidos?',
      a: 'Sí, si realizas tu compra hoy, los 5 bonos adicionales están incluidos completamente gratis.'
    }].map((faq, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-170">
          <h3 className="font-montserrat font-bold text-lg text-slate-900 mb-2" data-id="element-171">
            {faq.q}
          </h3>
          <p className="font-inter text-slate-600" data-id="element-172">{faq.a}</p>
        </div>)}
    </div>
  </Section>;
export const ClosingSection = () => <Section className="bg-white text-center pb-24 sm:pb-16" data-id="element-173">
    <h2 className="font-montserrat font-black text-3xl sm:text-4xl md:text-5xl text-slate-900 mb-8 max-w-4xl mx-auto leading-tight" data-id="element-174">
      Dale a tu hijo herramientas para aprender con más atención, confianza y
      comprensión.
    </h2>

    <a href={CHECKOUT_URL} className="block w-full max-w-4xl mx-auto mb-8 hover:opacity-95 transition-opacity" data-id="element-175">
      <img src={MAIN_IMAGE} alt="Sistema Completo" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-176" />
    </a>

    <div className="flex flex-wrap justify-center gap-4 mb-8 font-inter font-bold text-slate-700" data-id="element-177">
      <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full flex items-center gap-2" data-id="element-178">
        <Check className="w-4 h-4" data-id="element-179" /> Acceso inmediato
      </span>
      <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full flex items-center gap-2" data-id="element-180">
        <Check className="w-4 h-4" data-id="element-181" /> Descarga digital
      </span>
      <span className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full flex items-center gap-2" data-id="element-182">
        <Check className="w-4 h-4" data-id="element-183" /> Uso ilimitado
      </span>
    </div>

    <div className="mb-8" data-id="element-184">
      <p className="font-montserrat font-black text-5xl text-red-600 mb-2" data-id="element-185">
        🔥 USD $10.99
      </p>
    </div>

    <CTAButton text="🧠 QUIERO ACCESO INMEDIATO" className="max-w-2xl transform scale-110 mb-8" data-id="element-186" />

    <img src="https://cdn.shopify.com/s/files/1/0533/2089/files/safe-checkout.png" alt="Pago Seguro" className="h-12 mx-auto opacity-50 grayscale" data-id="element-187" />
  </Section>;